import { render, staticRenderFns } from "./LogoCard.vue?vue&type=template&id=5683e65a&scoped=true&"
import script from "./LogoCard.vue?vue&type=script&lang=js&"
export * from "./LogoCard.vue?vue&type=script&lang=js&"
import style0 from "./LogoCard.vue?vue&type=style&index=0&id=5683e65a&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5683e65a",
  null
  
)

export default component.exports